import { BaseContainerModel } from "../base-container.model";
import {  bl_wms_grn_processing_queue_RowClass} from "../../dbschema/index";

export class WmsGrnMultiProcessingQueueContainer extends BaseContainerModel {
    bl_wms_grn_processing_queues: bl_wms_grn_processing_queue_RowClass[] = [];
}
